export const getApiKeyMutationKey = () => [`planner_apikey`];
